import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

// LIBS
import API from "../../../api";
import {
  fioLitleTruncateFromObject,
  sumFormat
} from "../../../lib/helpers/strings";
import { getLabelItem, getPriceItem } from "../../../lib/helpers/items";

// UI
import { Header, Table } from "../../../ui";
// import IconEdit from "../../../ui/src/ui/components/icons/edit";

export default class TableItems extends Component {
  static propTypes = {
    biletId: PropTypes.string.isRequired
  };

  state = {
    loading: true,
    items: []
  };

  async componentDidMount() {
    const { biletId } = this.props;

    const items = await API.bilets.getBiletItems(biletId);
    this.setState({ items, loading: false });
  }

  getTableColumnsItems = () => {
    return [
      {
        title: "",
        className: "id",
        render: ({ i }) => 1 + i,
        footer: {}
      },
      {
        title: "Название",
        suffix: "вещи",
        field: "name",
        footer: { colSpan: 4, title: "ИТОГО" }
      },
      {
        title: "Страна",
        suffix: "производитель",
        render: ({ item }) => {
          console.log(item);

          return !!item.from_bilet_type && item.from_bilet_type === "mobile"
            ? ""
            : (item.prices && item.prices.country_title) || "";
        }
      },
      {
        title: "Проба",
        suffix: "золота",
        render: ({ item }) =>
          !!item.from_bilet_type && item.from_bilet_type === "mobile"
            ? ""
            : (item.prices && item.prices.prob_title) || ""
      },
      {
        title: "Цена",
        suffix: "пробы",
        text: "right",
        render: ({ item }) =>
          !!item.from_bilet_type && item.from_bilet_type === "mobile"
            ? ""
            : sumFormat(item.prices ? getPriceItem(item) : 0)
      },
      {
        title: "Граммы",
        suffix: "золото",
        text: "right",
        render: ({ item }) =>
          !!item.from_bilet_type && item.from_bilet_type === "mobile"
            ? ""
            : sumFormat(item.gramm),
        footer: {
          plus: ({ item }) =>
            !!item.from_bilet_type && item.from_bilet_type === "mobile"
              ? 0
              : parseFloat(item.gramm),
          render: ({ result }) => sumFormat(parseFloat(result).toFixed(1))
        }
      },
      {
        title: "Граммы",
        suffix: "всего",
        text: "right",
        render: ({ item }) => sumFormat(item.gramm_all),
        footer: {
          plus: ({ item }) =>
            !!item.from_bilet_type && item.from_bilet_type === "mobile"
              ? 0
              : parseFloat(item.gramm_all),
          render: ({ result }) => sumFormat(parseFloat(result).toFixed(1))
        }
      },
      {
        title: "Цена",
        suffix: "золота",
        text: "right",
        render: ({ item }) => sumFormat(item.sum),
        footer: {
          plus: ({ item }) => parseInt(item.sum, 10),
          render: ({ result }) => sumFormat(result)
        }
      },
      {
        title: "Метка",
        suffix: "Состояния",
        render: ({ item }) => {
          const labelStatus = getLabelItem(item);

          return (
            <span className={`label size-small label-${labelStatus.style}`}>
              {labelStatus.title}
            </span>
          );
        },
        footer: { colSpan: 2 }
      },
      {
        title: "Ответсвенный",
        suffix: "за оценку",
        render: ({ item }) => {
          return (
            <Link to={`/users/${item.user_id._id}`}>
              {fioLitleTruncateFromObject(item.user_id)}
            </Link>
          );
        }
      }
    ];
  };

  render() {
    return (
      <div>
        <Header size={4}>Вещи</Header>

        <Table
          columns={this.getTableColumnsItems()}
          data={this.state.items}
          loading={this.state.loadingItems}
        />
      </div>
    );
  }
}
